import http from '@/utils/ajax'
import { CLAIMS_STAGING_INIT_SUCCESS, CLAIMS_STAGING_INIT_LOADING, CLAIMS_STAGING_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {}
}

const getters = {

}

const mutations = {
  [CLAIMS_STAGING_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [CLAIMS_STAGING_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [CLAIMS_STAGING_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  }
}

const actions = {
  async claimStagingInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.claimStaging
    commit(CLAIMS_STAGING_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(CLAIMS_STAGING_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(CLAIMS_STAGING_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
